export default {
  pt: {
    // A situação da FRENTE DE TRABALHO, que rotula a coluna, o filtro e os
    // indicadores da grade (Samuel, 18/09/2026).
    'contracts.contractsPage.situacao.planned': 'Previsto',
    'contracts.contractsPage.situacao.awaitingRelease': 'Aguardando liberação',
    'contracts.contractsPage.situacao.inProgress': 'Em andamento',
    'contracts.contractsPage.situacao.halted': 'Paralisado',
    'contracts.contractsPage.situacao.completed': 'Finalizado',
    'contracts.contractsPage.situacao.completedPending': 'Finalizado c/ pendência',
    'contracts.contractsPage.searchSituation': 'Buscar situação...',
    'contracts.contractsPage.pair': 'Dupla',
    'contracts.contractsPage.noPair': 'Não registrada',
    'contracts.contractsPage.searchPair': 'Buscar dupla...',
    'contracts.contractsPage.contract': 'Contrato',
    'contracts.contractsPage.producer': 'Produtor',
    'contracts.contractsPage.city': 'Município',
    'contracts.contractsPage.destination': 'Destino',
    'contracts.contractsPage.hectares': 'Área',
    'contracts.contractsPage.local': 'Fazenda e destino',
    'contracts.contractsPage.km': 'Distância',
    'contracts.contractsPage.subcontract': 'Subcontrato',
    'contracts.contractsPage.subcontractPending': 'Apontar',
    'contracts.contractsPage.situation': 'Situação',
    'contracts.contractsPage.harvestPct': '% colheita',
    'contracts.contractsPage.loads': 'Cargas',
    // Hectares e cargas atendidas do portal (Samuel, 04/11/2026).
    'contracts.atendimento.hectares': 'Hectares atendidos',
    'contracts.atendimento.cargas': 'Cargas atendidas',
    'contracts.atendimento.de': 'de',
    'contracts.atendimento.hectaresAjuda': 'Hectares lançados no Maquinário da frente, contra a área cadastrada dos contratos do filtro.',
    'contracts.atendimento.cargasAjuda': 'Cargas liberadas, contra as cargas previstas dos contratos do filtro.',
    'contracts.contractsPage.title': 'Contratos',
    'contracts.contractsPage.newContract': 'Novo contrato',
    'contracts.contractsPage.search': 'Buscar contrato...',
    'contracts.contractsPage.emptySearch': 'Nenhum contrato encontrado para "{{query}}".',
    'contracts.contractsPage.empty': 'Nenhum contrato.',
    'contracts.contractsPage.deleteTitle': 'Excluir o contrato {{number}}?',
    'contracts.contractsPage.deleteMessage': 'As cargas vinculadas ficam no histórico como órfãs e podem voltar pelo de-para de viagens quando outro contrato ganhar o vínculo com o ERP. A exclusão não pode ser desfeita.',
    'contracts.contractsPage.removed': 'Contrato excluído.',
  },
  en: {
    'contracts.contractsPage.situacao.planned': 'Planned',
    'contracts.contractsPage.situacao.awaitingRelease': 'Awaiting release',
    'contracts.contractsPage.situacao.inProgress': 'In progress',
    'contracts.contractsPage.situacao.halted': 'Halted',
    'contracts.contractsPage.situacao.completed': 'Completed',
    'contracts.contractsPage.situacao.completedPending': 'Completed w/ pending issue',
    'contracts.contractsPage.searchSituation': 'Search situation...',
    'contracts.contractsPage.pair': 'Pair',
    'contracts.contractsPage.noPair': 'Not registered',
    'contracts.contractsPage.searchPair': 'Search pair...',
    'contracts.contractsPage.contract': 'Contract',
    'contracts.contractsPage.producer': 'Producer',
    'contracts.contractsPage.city': 'City',
    'contracts.contractsPage.destination': 'Destination',
    'contracts.contractsPage.hectares': 'Area',
    'contracts.contractsPage.local': 'Farm and destination',
    'contracts.contractsPage.km': 'Distance',
    'contracts.contractsPage.subcontract': 'Subcontract',
    'contracts.contractsPage.subcontractPending': 'To match',
    'contracts.contractsPage.situation': 'Situation',
    'contracts.contractsPage.harvestPct': '% harvest',
    'contracts.contractsPage.loads': 'Loads',
    'contracts.atendimento.hectares': 'Hectares served',
    'contracts.atendimento.cargas': 'Loads served',
    'contracts.atendimento.de': 'of',
    'contracts.atendimento.hectaresAjuda': 'Hectares entered in the field machinery, against the registered area of the filtered contracts.',
    'contracts.atendimento.cargasAjuda': 'Released loads, against the planned loads of the filtered contracts.',
    'contracts.contractsPage.title': 'Contracts',
    'contracts.contractsPage.newContract': 'New contract',
    'contracts.contractsPage.search': 'Search contract...',
    'contracts.contractsPage.emptySearch': 'No contracts found for "{{query}}".',
    'contracts.contractsPage.empty': 'No contracts.',
    'contracts.contractsPage.deleteTitle': 'Delete contract {{number}}?',
    'contracts.contractsPage.deleteMessage': 'Linked loads stay in the history as orphans and can come back through the trip matching when another contract takes the ERP link. Deletion cannot be undone.',
    'contracts.contractsPage.removed': 'Contract deleted.',
  },
  es: {
    'contracts.contractsPage.situacao.planned': 'Previsto',
    'contracts.contractsPage.situacao.awaitingRelease': 'Esperando liberación',
    'contracts.contractsPage.situacao.inProgress': 'En curso',
    'contracts.contractsPage.situacao.halted': 'Paralizado',
    'contracts.contractsPage.situacao.completed': 'Finalizado',
    'contracts.contractsPage.situacao.completedPending': 'Finalizado c/ pendiente',
    'contracts.contractsPage.searchSituation': 'Buscar situación...',
    'contracts.contractsPage.pair': 'Pareja',
    'contracts.contractsPage.noPair': 'No registrada',
    'contracts.contractsPage.searchPair': 'Buscar pareja...',
    'contracts.contractsPage.contract': 'Contrato',
    'contracts.contractsPage.producer': 'Productor',
    'contracts.contractsPage.city': 'Municipio',
    'contracts.contractsPage.destination': 'Destino',
    'contracts.contractsPage.hectares': 'Área',
    'contracts.contractsPage.local': 'Hacienda y destino',
    'contracts.contractsPage.km': 'Distancia',
    'contracts.contractsPage.subcontract': 'Subcontrato',
    'contracts.contractsPage.subcontractPending': 'Asignar',
    'contracts.contractsPage.situation': 'Situación',
    'contracts.contractsPage.harvestPct': '% cosecha',
    'contracts.contractsPage.loads': 'Cargas',
    'contracts.atendimento.hectares': 'Hectáreas atendidas',
    'contracts.atendimento.cargas': 'Cargas atendidas',
    'contracts.atendimento.de': 'de',
    'contracts.atendimento.hectaresAjuda': 'Hectáreas registradas en la maquinaria del frente, contra el área registrada de los contratos del filtro.',
    'contracts.atendimento.cargasAjuda': 'Cargas liberadas, contra las cargas previstas de los contratos del filtro.',
    'contracts.contractsPage.title': 'Contratos',
    'contracts.contractsPage.newContract': 'Nuevo contrato',
    'contracts.contractsPage.search': 'Buscar contrato...',
    'contracts.contractsPage.emptySearch': 'No se encontraron contratos para "{{query}}".',
    'contracts.contractsPage.empty': 'No hay contratos.',
    'contracts.contractsPage.deleteTitle': '¿Eliminar el contrato {{number}}?',
    'contracts.contractsPage.deleteMessage': 'Las cargas vinculadas quedan en el historial como huérfanas y pueden volver por el cruce de viajes cuando otro contrato reciba el vínculo con el ERP. La eliminación no se puede deshacer.',
    'contracts.contractsPage.removed': 'Contrato eliminado.',
  },
}
